function setLocale(state, locale) {
	state.locale = locale;
}

function setSettings(state, settings) {
	state.allAvailableSettings = settings;
}

function setParameterChanged(state, { parameter, changed }) {
	let index  = state.allAvailableSettings.map((x) => x.id).indexOf(parameter.id);
	state.allAvailableSettings[index].changed = changed;
}

function setParametersAsUnchanged(state) {
	state.allAvailableSettings.filter(x => x.changed).forEach(settings => {
		settings.changed = false;
	});
}

function setLoading(state, { key, isLoading }) {
	state.loading[key] = isLoading;
}

export default { setLocale, setSettings, setParameterChanged, setParametersAsUnchanged, setLoading };
